define((require) => {
    "use strict";

    const Actions               = require("shared/ui/experience/action/Actions");
    const PolymorphicCollection = require("shared/zbone/PolymorphicCollection");

    /**
     * A collection of actions.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ActionCollection
     * @constructor
     */
    return PolymorphicCollection.extend("ActionCollection", {
        modelTypes: Actions
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/ActionCollection.js